import _toConsumableArray from "/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { __rest } from "tslib";
import { selector as parseSelector } from 'vega-event-selector';
import { identity, isArray, stringValue } from 'vega-util';
import { forEachSelection, MODIFY, STORE, unitName, VL_SELECTION_RESOLVE, TUPLE } from '.';
import { dateTimeToExpr, isDateTime, dateTimeToTimestamp } from '../../datetime';
import { keys, varName } from '../../util';
import { isUnitModel } from '../model';
import { forEachTransform } from './transforms/transforms';
import { parseSelectionBinExtent } from './parse';
export function assembleInit(init) {
  var isExpr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;

  if (isArray(init)) {
    var assembled = init.map(function (v) {
      return assembleInit(v, isExpr, wrap);
    });
    return isExpr ? "[".concat(assembled.join(', '), "]") : assembled;
  } else if (isDateTime(init)) {
    if (isExpr) {
      return wrap(dateTimeToExpr(init));
    } else {
      return wrap(dateTimeToTimestamp(init));
    }
  }

  return isExpr ? wrap(JSON.stringify(init)) : init;
}
export function assembleUnitSelectionSignals(model, signals) {
  forEachSelection(model, function (selCmpt, selCompiler) {
    var _signals;

    var name = selCmpt.name;
    var modifyExpr = selCompiler.modifyExpr(model, selCmpt);

    (_signals = signals).push.apply(_signals, _toConsumableArray(selCompiler.signals(model, selCmpt)));

    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.signals) {
        signals = txCompiler.signals(model, selCmpt, signals);
      }

      if (txCompiler.modifyExpr) {
        modifyExpr = txCompiler.modifyExpr(model, selCmpt, modifyExpr);
      }
    });
    signals.push({
      name: name + MODIFY,
      on: [{
        events: {
          signal: selCmpt.name + TUPLE
        },
        update: "modify(".concat(stringValue(selCmpt.name + STORE), ", ").concat(modifyExpr, ")")
      }]
    });
  });
  return cleanupEmptyOnArray(signals);
}
export function assembleFacetSignals(model, signals) {
  if (model.component.selection && keys(model.component.selection).length) {
    var name = stringValue(model.getName('cell'));
    signals.unshift({
      name: 'facet',
      value: {},
      on: [{
        events: parseSelector('mousemove', 'scope'),
        update: "isTuple(facet) ? facet : group(".concat(name, ").datum")
      }]
    });
  }

  return cleanupEmptyOnArray(signals);
}
export function assembleTopLevelSignals(model, signals) {
  var hasSelections = false;
  forEachSelection(model, function (selCmpt, selCompiler) {
    var name = selCmpt.name;
    var store = stringValue(name + STORE);
    var hasSg = signals.filter(function (s) {
      return s.name === name;
    });

    if (hasSg.length === 0) {
      var resolve = selCmpt.resolve === 'global' ? 'union' : selCmpt.resolve;
      var isMulti = selCmpt.type === 'multi' ? ', true)' : ')';
      signals.push({
        name: selCmpt.name,
        update: "".concat(VL_SELECTION_RESOLVE, "(").concat(store, ", ").concat(stringValue(resolve)).concat(isMulti)
      });
    }

    hasSelections = true;

    if (selCompiler.topLevelSignals) {
      signals = selCompiler.topLevelSignals(model, selCmpt, signals);
    }

    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.topLevelSignals) {
        signals = txCompiler.topLevelSignals(model, selCmpt, signals);
      }
    });
  });

  if (hasSelections) {
    var hasUnit = signals.filter(function (s) {
      return s.name === 'unit';
    });

    if (hasUnit.length === 0) {
      signals.unshift({
        name: 'unit',
        value: {},
        on: [{
          events: 'mousemove',
          update: 'isTuple(group()) ? group() : unit'
        }]
      });
    }
  }

  return cleanupEmptyOnArray(signals);
}
export function assembleUnitSelectionData(model, data) {
  var dataCopy = _toConsumableArray(data);

  forEachSelection(model, function (selCmpt) {
    var init = {
      name: selCmpt.name + STORE
    };

    if (selCmpt.init) {
      var fields = selCmpt.project.items.map(function (proj) {
        var signals = proj.signals,
            rest = __rest(proj, ["signals"]);

        return rest;
      });
      var insert = selCmpt.init.map(function (i) {
        return assembleInit(i, false);
      });
      init.values = selCmpt.type === 'interval' ? [{
        unit: unitName(model, {
          escape: false
        }),
        fields: fields,
        values: insert
      }] : insert.map(function (i) {
        return {
          unit: unitName(model, {
            escape: false
          }),
          fields: fields,
          values: i
        };
      });
    }

    var contains = dataCopy.filter(function (d) {
      return d.name === selCmpt.name + STORE;
    });

    if (!contains.length) {
      dataCopy.push(init);
    }
  });
  return dataCopy;
}
export function assembleUnitSelectionMarks(model, marks) {
  forEachSelection(model, function (selCmpt, selCompiler) {
    marks = selCompiler.marks ? selCompiler.marks(model, selCmpt, marks) : marks;
    forEachTransform(selCmpt, function (txCompiler) {
      if (txCompiler.marks) {
        marks = txCompiler.marks(model, selCmpt, marks);
      }
    });
  });
  return marks;
}
export function assembleLayerSelectionMarks(model, marks) {
  var _iterator = _createForOfIteratorHelper(model.children),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var child = _step.value;

      if (isUnitModel(child)) {
        marks = assembleUnitSelectionMarks(child, marks);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return marks;
}
export function assembleSelectionScaleDomain(model, extent) {
  var name = extent.selection;
  var selCmpt = model.getSelectionComponent(name, varName(name));
  return {
    signal: parseSelectionBinExtent(selCmpt, extent)
  };
}

function cleanupEmptyOnArray(signals) {
  return signals.map(function (s) {
    if (s.on && !s.on.length) delete s.on;
    return s;
  });
}